import { useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { ValidationMessage } from "sj-ui-toolkit/src/components";
import { ScoringRulesDialog } from "./ScoringRulesDialog";
import type { TournamentFormState } from "@/api/tournaments";

interface TournamentDescriptionProps {
  value: TournamentFormState["basicInfo"];
  onChange: (value: TournamentFormState["basicInfo"]) => void;
  showValidationMessages: boolean;
  isTournamentInProgress: boolean;
}

export function TournamentDescription({
  value,
  onChange,
  showValidationMessages,
  isTournamentInProgress,
}: TournamentDescriptionProps) {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleChange =
    (field: keyof TournamentFormState["basicInfo"]) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange({ ...value, [field]: e.target.value });
    };

  return (
    <>
      <div className="flex flex-col gap-4 p-5">
        <div>
          <FloatLabel className="mt-10">
            <InputText
              id="tournament-name"
              data-testid="tournament-name-input"
              className="w-full"
              value={value.name}
              onChange={handleChange("name")}
              disabled={isTournamentInProgress}
            />
            <label htmlFor="tournament-name">Tournament Name</label>
          </FloatLabel>
          {showValidationMessages && !value.name && (
            <div className="mt-2">
              <ValidationMessage severity="error" text="Tournament name is required" />
            </div>
          )}
        </div>
        <div>
          <FloatLabel className="mt-12">
            <InputTextarea
              id="tournament-description"
              data-testid="tournament-description-input"
              className="w-full"
              rows={4}
              value={value.description}
              onChange={handleChange("description")}
              disabled={isTournamentInProgress}
            />
            <label htmlFor="tournament-description">Tournament Description</label>
          </FloatLabel>
          {showValidationMessages && !value.description && (
            <div className="mt-2">
              <ValidationMessage severity="error" text="Tournament description is required" />
            </div>
          )}
        </div>
        <div>
          <Button
            className="body-sm m-0 px-0"
            text
            label="Scoring Details"
            onClick={() => setIsDialogVisible(true)}
          />
        </div>
      </div>
      <ScoringRulesDialog visible={isDialogVisible} onHide={() => setIsDialogVisible(false)} />
    </>
  );
}
